import * as yup from 'yup';
import mapValues from 'lodash/mapValues';
import { validationMode, validationMessages } from 'helpers/form';

export const compositeReturnTimeWindowShape = yup.object().shape({
  fromDate: yup
    .date()
    .typeError(validationMessages.required)
    .required(validationMessages.required),
  assetSelectionSetId: yup.string().required(validationMessages.required),
  tagRefPropertyDefinitionId: yup
    .number()
    .typeError(validationMessages.number)
    .nullable(true)
    .required(validationMessages.required),
  tagId: yup
    .number()
    .typeError(validationMessages.number)
    .nullable(true)
    .required(validationMessages.required),
});

/**
 * Validation Scheme used for Composite Return Benchmarks
 * @param mode Create | Edit - change the shape of the schema object based on Creating/Editing a benchmark.
 * @returns return yup schema object
 */
export const CompositeReturnValidationScheme = (
  mode: validationMode = validationMode.Create
) => {
  return yup.lazy((obj) =>
    yup.object(
      mapValues(obj, (value, key) => {
        switch (key) {
          case 'timeWindows':
            return mode === validationMode.Create
              ? yup.array().of(compositeReturnTimeWindowShape)
              : yup.mixed().notRequired();
          case 'name':
            return yup
              .string()
              .trim()
              .required(validationMessages.benchmarkNameNotEmpty);
          case 'calculationFrequencyId':
            return yup
              .number()
              .typeError(validationMessages.required)
              .required(validationMessages.required);
          case 'baseCurrencyCode':
            return yup
              .string()
              .typeError(validationMessages.required)
              .required(validationMessages.required);
          case 'customLagDate':
            return yup.string().when(['isLagged', 'setCustomLagDate'], {
              is: (isLagged: string, setCustomLagDate: string) =>
                isLagged === 'true' && setCustomLagDate === 'false',
              then: (schema) => schema.required('Please enter a valid date'),
              otherwise: (schema) => schema.notRequired(),
            });
          case 'description':
            return yup
              .string()
              .notRequired()
              .max(350, validationMessages.notExceed350);
          default:
            return yup.mixed().notRequired();
        }
      })
    )
  );
};
